// extracted by mini-css-extract-plugin
export default {"container":"bricks__container__jyEQw","video":"bricks__video__R0fnq","active":"bricks__active__xR1LG"};